import { enum_ } from 'valibot'

export enum BiomeTypeId {
  Plains = 1,
  Snow = 2,
  Desert = 3,
  Forest = 4,
  Ocean = 5,
  River = 6,
}

export const BiomeTypeIdSchema = enum_(BiomeTypeId, 'Invalid Biome Type')
